import React, { useState, useEffect, useRef } from 'react'
import {
  AppBar,
  Toolbar,
  useMediaQuery,
  useTheme,
  Autocomplete,
  TextField,
  Button,
  Popover,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Avatar
} from '@mui/material'
import { Images } from '../../global/GloblImages.tsx'
import HeaderMenu from './HeaderMenu.tsx'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Header_Menu from './Header_Menu.tsx'
import { ApiGetUserDetails, ApiPutShopperDetails } from '../../apiService/Core/Apicall.tsx'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Close } from '@mui/icons-material'
import { CustomUploadProfilePic } from '../../apiService/Core/CustomUploadProfilePic.tsx'
import store from '../../global/config/store.ts'
import { setLoadingFalse, setLoadingTrue } from '../../global/config/Action/loadingActions.ts'
import imageCompression from "browser-image-compression"
import { Upload } from 'lucide-react'

const Header: React.FC = () => {
  const [selectedRegion, setSelectedRegion] = useState<string | null>('')
  const [userRole, setUserRole] = useState<number | null>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const profileButtonRef = useRef<HTMLButtonElement | null>(null);
  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const [editProfileOpen, setEditProfileOpen] = useState(false);


  const open = Boolean(anchorEl);
  const id = open ? 'profile-popover' : undefined;
  const [userDetails, setUserDetails] = useState<any>()

  console.log("Open", open)
  console.log("anchorEL", anchorEl)
  const [regionData, setRegionData] = useState<any>(['United States', 'Europe', 'Asia', 'Africa', 'Oceania'])
  useEffect(() => {
    const role = localStorage.getItem('userRole')

    if (role) setUserRole(Number(role))
  }, [])

  const userId = localStorage.getItem('userId');


  // const getUserDetails = async () => {
  //   try {
  //     const res = await ApiGetUserDetails(userId);
  //     setUserDetails(res?.data);
  //     setAnchorEl(profileButtonRef.current);
  //   } catch (error) {
  //     console.log("Error", error);
  //   }
  // };

  const getUserDetails = async () => {
    try {
      const res = await ApiGetUserDetails(userId);
      setUserDetails(res?.data);
    } catch (error) {
      console.log("Error", error);
    }
  };


  useEffect(() => {
    if (!userDetails) {
      getUserDetails()
    }

  }, [userDetails])



  const handleRegionChange = (_: any, value: string | null) =>
    setSelectedRegion(value)

  // const handleProfileClick = () => console.log('Profile button clicked!')

  const handleLogout = () => {
    localStorage.removeItem('userRole')
    localStorage.removeItem('userToken')
    navigate('/login')
  }
  const icons: any = Images()


  const profileValidationSchema = Yup.object({
    firstName: Yup.string()
      .trim()
      .required("First name is required"),

    lastName: Yup.string()
      .trim()
      .required("Last name is required"),

    displayName: Yup.string()
      .trim()
      .required("Display name is required"),

    // profilePicUrl: Yup.string()
    //   .url("Enter a valid image URL")
    //   .defined(),
  });


  const uploadImage = async (file: File): Promise<string> => {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("fileType", "profile_pic");
    formData.append("userId", String(userDetails?.userId));

    try {
      const response = await CustomUploadProfilePic(formData);

      if (!response?.location) {
        throw new Error("Image URL was not returned by the server");
      }

      toast.success("Profile picture uploaded successfully");
      return response.location;
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      toast.error("Failed to upload profile picture");
      throw error;
    }
  };

  return (
    <div className='extra'>
      <ToastContainer />
      <AppBar
        position='sticky'
        className='custom-app-bar'
        sx={{ marginTop: isMobile ? '0' : '20px' }}
      >
        <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className='hdr-img'
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: 'white',
              padding: '5px',
              marginRight: 'auto',
              justifyContent: 'center',
              marginTop: '-15px',
              marginBottom: '-15px',
              boxShadow: '0 1px 2px -1px #0c0c0c1a, 0 1px 3px #0c0c0c1a ',
              borderRadius: '10px'
            }}
          >
            <img
              className='Profile_Images'
              src={icons.mmLogo}
              alt='Logo'
              style={{ height: '100px', maxWidth: '100%' }}
            />
          </div>
          {/* <HeaderMenu userRole={userRole} /> */}
          {/* <Autocomplete
          value={selectedRegion}
          className='Autocomplete_Bar'
          onChange={handleRegionChange}
          options={regionData}
          renderInput={params => (
            <TextField
              {...params}
              label='Select Region'
              variant='outlined'
              className='Region_bar'
              style={{
                marginLeft: '20px',
                minWidth: 180
              }}
              InputLabelProps={{
                style: { color: 'white', fontSize: '0.85rem' }
              }}
              InputProps={{
                ...params.InputProps,
                style: { color: 'white', fontSize: '0.85rem' }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: 'white' },
                  '&.Mui-focused fieldset': { borderColor: 'white' },
                  '& fieldset': { borderWidth: '1px', borderColor: 'white' }
                },
                '& .MuiInputLabel-root.Mui-focused': { color: 'white' }
              }}
            />
          )}
        /> */}
          <Box className='d-flex align-items-center w-100' justifyContent={{ xs: 'space-between', md: "end" }}>
            <Header_Menu userRole={userRole} />
            <Box className='d-flex align-items-center'>
              {/* <Button
                variant='contained'
                ref={profileButtonRef}
                // className="Profile_Button"
                onClick={getUserDetails}
                sx={{
                  marginLeft: '40px',
                  backgroundColor: 'transparent'

                  // backgroundColor: "#6e5b37",
                  // color: "white",
                  // "&:hover": { backgroundColor: "#5a4c2d" },
                  // display: "flex",
                  // alignItems: "center",
                  // padding: "8px 16px",
                }}
              > */}
              <Box ref={profileButtonRef} onClick={handleProfileClick} sx={{ cursor: 'pointer' }} className='d-flex justify-content-center ml-3'>
                <Avatar
                  src={userDetails?.profilePicUrl || undefined}
                  alt={userDetails?.displayName}
                  sx={{ width: 50, height: 50 }}
                >
                  {userDetails?.firstName?.charAt(0)?.toUpperCase()} {userDetails?.lastName?.charAt(0)?.toUpperCase()}
                </Avatar>
              </Box>
              {/* Profile */}
              {/* </Button> */}
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 2, minWidth: 400 }}>
                  <Box className='d-flex justify-content-center'>
                    <Avatar
                      src={userDetails?.profilePicUrl || undefined}
                      alt={userDetails?.displayName}
                      sx={{ width: 100, height: 100 }}
                    >
                      {userDetails?.firstName?.charAt(0)?.toUpperCase()} {userDetails?.lastName?.charAt(0)?.toUpperCase()}
                    </Avatar>
                  </Box>
                  <Typography className='mx-5 text-center my-2' fontWeight='bold' whiteSpace='nowrap' variant="h6">{userDetails?.displayName}</Typography>
                  <Typography className='mx-4 text-center my-2' fontWeight={600} variant="subtitle1">{userDetails?.email}</Typography>
                  <Typography className='text-center' fontWeight={600} variant="body1"> {userDetails?.role?.roleDisplayName}</Typography>
                  <Box className='d-flex align-items-center justify-content-center mt-3'>
                    <Button sx={{ background: '#75724C', color: "#FFF" }} className='mx-auto' onClick={() => {
                      setAnchorEl(null);
                      setEditProfileOpen(true);
                    }}>Edit</Button>
                  </Box>
                </Box>
              </Popover>

              <Button
                variant='contained'
                onClick={handleLogout}
                sx={{
                  marginLeft: '20px',
                  backgroundColor: 'transparent',
                  color: 'white',
                  '&:hover': { backgroundColor: 'transparent' },
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '8px',
                  minWidth: 'auto',
                  borderRadius: '50%'
                }}
              >
                <ExitToAppIcon />
              </Button>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>


      <Dialog
        open={editProfileOpen}
        onClose={() => setEditProfileOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            Edit Profile
            <IconButton onClick={() => setEditProfileOpen(false)}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>

        <Formik
          enableReinitialize
          initialValues={{
            userId: userDetails?.userId ?? "",
            firstName: userDetails?.firstName ?? "",
            lastName: userDetails?.lastName ?? "",
            displayName: userDetails?.displayName ?? "",
            profilePicUrl: userDetails?.profilePicUrl ?? "",
          }}
          validationSchema={profileValidationSchema}
          onSubmit={async (values) => {
            console.log("Profile values:", values);
            try {
              //Call API to update profile
              const response = await ApiPutShopperDetails(values)

              if (response) {
                getUserDetails()
                toast.success("Profile updated successfully")
                setEditProfileOpen(false)
              } else {
                toast.error("Failed to update profile")
              }
            } catch (error) {
              console.error("Error updating profile:", error)
              toast.error("An error occurred while updating profile")
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            isSubmitting,
          }) => {
            const handleProfileImageUpload = async (
              event: React.ChangeEvent<HTMLInputElement>
            ) => {
              const file = event.target.files?.[0];

              event.target.value = "";

              if (!file) return;

              if (!file.type.startsWith("image/")) {
                toast.error("Please select a valid image");
                return;
              }

              store.dispatch(setLoadingTrue());

              try {
                const compressedFile = await imageCompression(file, {
                  maxSizeMB: 1,
                  maxWidthOrHeight: 1024,
                  useWebWorker: true,
                });

                const liveUrl = await uploadImage(compressedFile);

                await setFieldValue("profilePicUrl", liveUrl);
              } catch (error) {
                console.error("Profile image upload failed:", error);
              } finally {
                store.dispatch(setLoadingFalse());
              }
            };

            return (
              <Form>
                <DialogContent dividers>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                    mb={3}
                  >
                    <Avatar
                      src={values.profilePicUrl || undefined}
                      alt={values.displayName}
                      sx={{ width: 100, height: 100 }}
                    >
                      {values.firstName?.charAt(0)?.toUpperCase()}
                    </Avatar>

                    <Box className='d-flex align-items-center' sx={{gap:2}}>
                      <Button component="label" variant="outlined" sx={{ border: '1px solid #75724c', color: '#75724c' }}>
                        Upload Profile Picture
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleProfileImageUpload}
                        />
                      </Button>
                      {values.profilePicUrl && (
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => setFieldValue("profilePicUrl", "")}
                        >
                          Remove Photo
                        </Button>
                      )}
                    </Box>
                  </Box>

                  <TextField
                    fullWidth
                    margin="normal"
                    label="Display Name"
                    name="displayName"
                    value={values.displayName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.displayName && errors.displayName)}
                    helperText={
                      touched.displayName &&
                        typeof errors.displayName === "string"
                        ? errors.displayName
                        : ""
                    }
                  />

                  <TextField
                    fullWidth
                    margin="normal"
                    label="First Name"
                    name="firstName"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.firstName && errors.firstName)}
                    helperText={
                      touched.firstName && typeof errors.firstName === "string"
                        ? errors.firstName
                        : ""
                    }
                  />

                  <TextField
                    fullWidth
                    margin="normal"
                    label="Last Name"
                    name="lastName"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.lastName && errors.lastName)}
                    helperText={
                      touched.lastName && typeof errors.lastName === "string"
                        ? errors.lastName
                        : ""
                    }
                  />
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                  <Button onClick={() => setEditProfileOpen(false)} sx={{ border: '1px solid #75724c', color: '#75724c' }}>
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    sx={{
                      backgroundColor: "#75724C",
                      "&:hover": { backgroundColor: "#625F3E" },
                    }}
                  >
                    Save Changes
                  </Button>
                </DialogActions>
              </Form>
            )
          }}
        </Formik>
      </Dialog>

    </div>
  )
}

export default Header
